import { Http } from '@angular/http';
import { Injectable } from '@angular/core';
import { Response } from '@angular/http';

import { Observable, of } from 'rxjs';
import { map, tap, finalize, share } from 'rxjs/operators';

@Injectable()
export class UISvgIconService {

    private _iconsByUrl = new Map<string, SVGElement>();

    private _iconsLoadingByUrl = new Map<string, Observable<SVGElement>>();

    constructor(private _http: Http) {
    }

    loadSvg(url: string): Observable<SVGElement> {
        if (this._iconsByUrl.has(url)) {
            return of(this._iconsByUrl.get(url));
        } else if (this._iconsLoadingByUrl.has(url)) {
            return this._iconsLoadingByUrl.get(url);
        } else {
            const svg = <Observable<SVGElement>>this._http
                .get(url)
                .pipe(
                    map((res: Response) => {
                        const div = document.createElement('DIV');
                        div.innerHTML = res.text();
                        return div.querySelector('svg');
                    }),
                    tap(s => this._iconsByUrl.set(url, s)),
                    finalize(() => this._iconsLoadingByUrl.delete(url)),
                    share()
                );

            this._iconsLoadingByUrl.set(url, svg);
            return svg;
        }
    }
}